'use client';
import React, { useState, useEffect, useCallback } from 'react';

const slides = [
{
  id: 1,
  src: 'https://coffeebythebay.com/cdn/shop/files/IMG_1553_2_1080x.jpg?v=1613541601',
  alt: 'Bayside Coffee Co. interior shop view with coffee equipment'
},
{
  id: 2,
  src: 'https://coffeebythebay.com/cdn/shop/files/E3691850-25A4-49CE-B698-1F2ACE848A6A_1296x.jpg?v=1613547965',
  alt: 'Bayside Coffee Co. coffee cups and brewing setup'
},
{
  id: 3,
  src: 'https://coffeebythebay.com/cdn/shop/files/IMG_1610_1296x.jpg?v=1613544941',
  alt: 'Bayside Coffee Co. fresh brewed coffee close-up'
},
{
  id: 4,
  src: 'https://coffeebythebay.com/cdn/shop/files/076315C7-5B16-4243-96EE-76046D640506_1296x.jpg?v=1649688767',
  alt: 'Bayside Coffee Co. outdoor seating area at Eastpoint location'
},
{
  id: 5,
  src: 'https://coffeebythebay.com/cdn/shop/files/1469B7BB-41B0-44E6-919A-DF6104BB5CF6_1296x.jpg?v=1649688180',
  alt: 'Bayside Coffee Co. roasting equipment and coffee beans'
},
{
  id: 6,
  src: 'https://coffeebythebay.com/cdn/shop/files/C7A75822-EB3D-4118-9D28-5EEEF296DA1F_1296x.jpg?v=1649688245',
  alt: 'Bayside Coffee Co. team members and shop atmosphere'
}];


export default function SlideshowSection() {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides?.length);
  }, []);

  const goPrev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + slides?.length) % slides?.length);
  }, []);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(goNext, 3000);
    return () => clearInterval(timer);
  }, [paused, goNext]);

  return (
    <section className="slideshow-section">
      <div className="slideshow-wrapper">
        {/* Slides */}
        {slides?.map((slide, i) =>
        <div
          key={slide?.id}
          className={`slide ${i === current ? 'slide--active' : ''}`}
          style={{
            backgroundImage: `url('${slide?.src}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          aria-hidden={i !== current}>
          
            <div className="slide-overlay" />
          </div>
        )}

        {/* Controls */}
        <div className="slideshow-controls">
          <div className="slideshow-arrows">
            <button className="arrow-btn arrow-btn--left" onClick={goPrev} aria-label="Previous slide">
              <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 7 11" width="7" height="11">
                <path d="M5.5.037a1.5 1.5 0 0 1 1.06 2.56l-2.94 2.94 2.94 2.94a1.5 1.5 0 0 1-2.12 2.12l-4-4a1.5 1.5 0 0 1 0-2.12l4-4A1.5 1.5 0 0 1 5.5.037z" fill="#fff" />
              </svg>
            </button>
            <button className="arrow-btn arrow-btn--right" onClick={goNext} aria-label="Next slide">
              <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 7 11" width="7" height="11">
                <path d="M1.5 11A1.5 1.5 0 0 1 .44 8.44L3.38 5.5.44 2.56A1.5 1.5 0 0 1 2.56.44l4 4a1.5 1.5 0 0 1 0 2.12l-4 4A1.5 1.5 0 0 1 1.5 11z" fill="#fff" />
              </svg>
            </button>
            <ul className="slide-dots">
              {slides?.map((_, i) =>
              <li key={i}>
                  <button
                  className={`dot-btn ${i === current ? 'dot-btn--active' : ''}`}
                  onClick={() => setCurrent(i)}
                  aria-label={`Load slide ${i + 1}`} />
                
                </li>
              )}
            </ul>
          </div>
          <button
            className="pause-btn"
            onClick={() => setPaused(!paused)}
            aria-label={paused ? 'Play slideshow' : 'Pause slideshow'}>
            
            {paused ?
            <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 20 40" width="14" height="14">
                <path fillRule="evenodd" clipRule="evenodd" d="M23.6 16.8L7 1.5C5.6.3 4 .2 2.9.7 1.6 1.4.8 2.7.7 3.8v31.7c0 1.8 1.1 3.3 3.1 3.3 1.5 0 2.5-.5 3.4-1.4l16.4-15.7c1.5-1.4 1.5-3.6 0-4.9z" fill="#fff" />
              </svg> :

            <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 9.52 11" width="14" height="14">
                <path d="M1.5 11A1.5 1.5 0 0 1 0 9.5v-8a1.5 1.5 0 0 1 3 0v8A1.5 1.5 0 0 1 1.5 11zM8 11a1.5 1.5 0 0 1-1.5-1.5v-8a1.5 1.5 0 1 1 3 0v8A1.5 1.5 0 0 1 8 11z" fill="#fff" />
              </svg>
            }
            <span className="pause-label">{paused ? 'Play slideshow' : 'Pause slideshow'}</span>
          </button>
        </div>
      </div>
      <style jsx>{`
        .slideshow-section {
          width: 100%;
          position: relative;
        }
        .slideshow-wrapper {
          position: relative;
          width: 100%;
          height: 500px;
          overflow: hidden;
          background: #222;
        }
        .slide {
          position: absolute;
          inset: 0;
          opacity: 0;
          transition: opacity 0.5s ease;
        }
        .slide--active {
          opacity: 1;
        }
        .slide-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.1);
        }
        .slideshow-controls {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px 20px;
          z-index: 10;
        }
        .slideshow-arrows {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .arrow-btn {
          background: rgba(0,0,0,0.3);
          border: none;
          cursor: pointer;
          padding: 10px 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s;
        }
        .arrow-btn:hover {
          background: rgba(0,0,0,0.5);
        }
        .slide-dots {
          list-style: none;
          margin: 0;
          padding: 0;
          display: flex;
          gap: 6px;
          align-items: center;
        }
        .dot-btn {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          border: none;
          cursor: pointer;
          padding: 0;
          transition: background 0.2s;
        }
        .dot-btn--active {
          background: #fff;
        }
        .pause-btn {
          background: none;
          border: none;
          cursor: pointer;
          color: #fff;
          display: flex;
          align-items: center;
          gap: 6px;
          margin-left: 16px;
          padding: 8px;
        }
        .pause-label {
          font-size: 12px;
          color: #fff;
          font-family: 'Work Sans', sans-serif;
        }
        @media (max-width: 749px) {
          .slideshow-wrapper {
            height: 280px;
          }
        }
      `}</style>
    </section>);

}